module.exports = __webpack_public_path__ + "bin/d07899d1e2b37f41c7326c82608ccd32.svg";